import React from 'react'

import s from './Col.module.css'

const Col = ({ children }) => {
  return <div className={s.col}>{children}</div>
}

export default Col
